import { reactive } from "vue";
import type { ComponentPublicInstance } from "vue";

export type TourAnchorId =
  | "jobs-nav"
  | "new-job"
  | "new-job-menu"
  | "job-card"
  | "job-card-edit"
  | "ask-entry"
  | "ask-composer";

const anchors = reactive(new Map<TourAnchorId, HTMLElement>());

// Ownership-safe unregister: a null callback deletes the id only if it still maps to this call site's element,
// so a remount's old teardown can't evict the replacement.
export const tourAnchorRef = (id: TourAnchorId) => {
  let owned: HTMLElement | null = null;
  return (el: Element | ComponentPublicInstance | null): void => {
    if (el) {
      owned = (el instanceof Element ? el : el.$el) as HTMLElement;
      anchors.set(id, owned);
      return;
    }
    if (owned && anchors.get(id) === owned) {
      anchors.delete(id);
    }
    owned = null;
  };
};

export const getTourAnchor = (id: TourAnchorId): HTMLElement | undefined =>
  anchors.get(id);
